import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getTaxesFeesWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_TAXFEE_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};